import { render } from "./DetailNavigation.vue?vue&type=template&id=364fd5e1&scoped=true"
import script from "./DetailNavigation.vue?vue&type=script&lang=js"
export * from "./DetailNavigation.vue?vue&type=script&lang=js"

import "./DetailNavigation.vue?vue&type=style&index=0&id=364fd5e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364fd5e1"]])

export default __exports__